import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

/**
 * autoHeight sets inline height: 0px when slides use aspect-ratio layout.
 * @param {import('swiper').Swiper} swiper
 */
function clearForcedHeights(swiper) {
	swiper.wrapperEl.style.removeProperty('height');
	swiper.el.style.removeProperty('height');
}

/**
 * @param {HTMLElement} section
 */
function initSectionSwiper(section) {
	const el = section.querySelector('.js-testimonials-swiper');
	const prevBtn = section.querySelector('.js-testimonials-prev');
	const nextBtn = section.querySelector('.js-testimonials-next');
	const nav = section.querySelector('.testimonials__nav');
	const slides = el?.querySelectorAll('.swiper-slide') ?? [];

	if (!el || slides.length < 2) {
		nav?.setAttribute('hidden', 'hidden');
		return null;
	}

	// Hide the nav when all slides fit (locked); show it when scrolling is needed.
	const toggleNav = (sw) => nav?.toggleAttribute('hidden', sw.isLocked);

	// iOS/WebKit chokes on transform-mode carousels (blank/frozen slides,
	// dead nav — see client-testimonials-swiper.js for the history). Native
	// scroll + scroll-snap on touch devices sidesteps that bug family.
	const isCoarsePointer = window.matchMedia?.('(pointer: coarse)').matches ?? false;

	const swiper = new Swiper(el, {
		modules: [Navigation],
		slidesPerView: 'auto',
		spaceBetween: 24,
		watchOverflow: true,
		cssMode: isCoarsePointer,
		// Keep the drag on the carousel instead of losing it to iOS Safari's
		// edge swipe-back gesture (#128).
		edgeSwipeDetection: 'prevent',
		observer: true,
		observeParents: true,
		navigation: {
			prevEl: prevBtn,
			nextEl: nextBtn,
		},
		breakpoints: {
			640: {
				spaceBetween: 32,
			},
			1100: {
				spaceBetween: 40,
			},
		},
		on: {
			init(s) {
				toggleNav(s);
				clearForcedHeights(s);
			},
			lock: toggleNav,
			unlock: toggleNav,
			resize(s) {
				toggleNav(s);
				clearForcedHeights(s);
			},
			update(s) {
				clearForcedHeights(s);
			},
		},
	});

	clearForcedHeights(swiper);

	return swiper;
}

export function initTestimonialsSwiper() {
	document.querySelectorAll('.js-testimonials-section').forEach((section) => {
		const el = section.querySelector('.js-testimonials-swiper');
		if (!el || el.swiper) {
			return;
		}

		initSectionSwiper(section);
	});
}
